import { render, staticRenderFns } from "./DataAnalysisDetails.vue?vue&type=template&id=836c8c72&"
import script from "./DataAnalysisDetails.vue?vue&type=script&lang=js&"
export * from "./DataAnalysisDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports